import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/article/page";
import PlatformComparison from "@/pages/comparison/page";
import CategoryGuide from "@/pages/category-guide/page";
import SafetyGuide from "@/pages/safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/spreadsheet-platform-comparison",
    element: <PlatformComparison />,
  },
  {
    path: "/spreadsheet-category-guide",
    element: <CategoryGuide />,
  },
  {
    path: "/safe-shopping-guide",
    element: <SafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;